import type { KambiRewardType, KambiValidReward } from '@mobi/api-types/kambi/player/reward'

export function getKambiRewardDescription(reward: KambiValidReward): string {
  let description = ''

  const metaTagDescription = reward.metadata?.tags.find(tag => tag.key === 'rewardDescription')
  if (metaTagDescription) {
    description += metaTagDescription.value
  }

  if (!description) {
    description += rewardDescriptionMap[reward.rewardType]
  }

  return description
}

// =============
// Local Helpers
// =============

const rewardDescriptionMap: Record<KambiRewardType, string> = {
  FREE_BET:
    'A free bet can be used instead of real money to fund a bet. If the bet wins then the payout will not include the stake of the bet.',
  PROFIT_BOOST: 'A profit boost is a reward that increases the combination odds.',
  ODDS_BOOST: 'An odds boost is a reward that specifies fixed odds for an outcome.',
  BEST_ODDS: 'Best odds guaranteed reward is specific to horse and dog racing. ',
  SECOND_CHANCE:
    'A second chance bet is a reward that gives you a free bet if your first bet loses.',
}
